// extracted by css-extract-rspack-plugin
export default {"anchor":"anchor-O_IDHB","videoButton":"videoButton-zM5TYp","videoButtonIcon":"videoButtonIcon-ShP3Lb","watchOnTwitter":"watchOnTwitter-al_H1D","viewReplies":"viewReplies-OPYEVc"};